<template>
    <div class="col-12">
        <div class="form-row justify-content-between">
            <h6 class="mr-2">Passenger {{ value.id }} ({{ ageRange }})</h6>
            <div v-if="value.passengerId == 1" class="custom-control custom-switch">
                <input v-model="clientIsTravelling" type="checkbox" class="custom-control-input" id="isClientTravelling">
                <label class="custom-control-label" for="isClientTravelling">Are you travelling on the trip?</label>
            </div>
        </div>
        <div class="form-row align-items-top">
            <div class="col-xs-12 col-md-2">
                <div class="input-group mb-3">
                    <select :value="value.title" 
                        @change="updateValue('title', $event.target.value)"
                        class="form-control" :class="{ invalid: $v.value.title.$error }"
                        :disabled="!value.editable">
                        <option disabled 
                                selected 
                                value="" 
                                aria-placeholder="Choose Title">
                                Choose Title
                        </option>
                        <option v-for="title in titles" 
                                :key="title.titleId" 
                                :value="title.name"
                                :aria-placeholder="title.name"
                                class="form-control-item">
                                {{ title.name }}
                        </option>
                    </select>
                </div>
                <div v-if="$v.value.title.$error" class="validation-message mb-3">Please select your title</div>
            </div>
            
            <div class="col-xs-12 col-md">
                <div class="input-group mb-3">
                    <input v-model="value.firstName" 
                            @input="updateValue('firstName', $event.target.value)" 
                            @blur="$v.value.firstName.$touch()" 
                            :disabled="!value.editable"
                            type="text" 
                            class="form-control" :class="{ invalid: $v.value.firstName.$error }" 
                            id="firstName" 
                            aria-label="First name"
                            placeholder="First name">
                </div>
                <div v-if="$v.value.firstName.$error" class="validation-message mb-3">Please enter your first name</div>
            </div>

            <div class="col-xs-12 col-md">
                <div class="input-group mb-3">
                    <input v-model="value.lastName" 
                        @input="updateValue('lastName', $event.target.value)"
                        @blur="$v.value.lastName.$touch()" 
                        :disabled="!value.editable"
                        type="text" 
                        class="form-control" :class="{ invalid: $v.value.lastName.$error }" 
                        id="lastName" 
                        aria-label="Last name"
                        placeholder="Last name">
                </div>
                <div v-if="$v.value.lastName.$error" class="validation-message mb-3">Please enter your last name</div>
            </div>

            <div class="col-12">
                <div class="input-group mb-3">
                    <input v-model="value.dietaryRequirements" 
                        @input="updateValue('dietaryRequirements', $event.target.value)"
                        type="text" 
                        class="form-control" 
                        id="dietaryRequirements" 
                        aria-label="Dietary Requirements"
                        placeholder="Dietary Requirements">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    props: [ 'value' ],
    computed: { 
        ageRange() {
            if (this.value.age == 'INF') {
                return 'Infant';
            } else if (this.value.age == 'CHD') {
                return 'Child';
            }
            return 'Adult';
        },
        clientIsTravelling: { 
            get() { 
                return !this.value.editable;
            },
            set(value) {
                if (value) {
                    let client = this.$store.state.passengers.client;
                    this.value.title = client.title;
                    this.value.firstName = client.firstName;
                    this.value.lastName = client.lastName;
                    this.value.editable = false;
                } else {
                    this.value.title = '';
                    this.value.firstName = '';
                    this.value.lastName = '';
                    this.value.editable = true;
                }
                this.value.editable = !value;
            }
        },
        titles() { 
            return this.$store.state.static.titles;
        }
    },
    methods: { 
        updateValue(key, value) {
            this.$emit('input', { ...this.value, [key]: value });
        },
    },
    validations: {
        value: {
            required,
            title: { required },
            firstName: { required },
            lastName: { required },
        }
    },
}
</script>